import React, { useEffect, useState } from 'react';
import { addFormData, fetchAllDataAPI } from '../../utils/api';
import Skeleton from 'react-loading-skeleton';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import withAuth from '../../utils/withAuth';

const TopProductSale = () => {
    const [topproduct, setTopProduct] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });

    useEffect(() => {
        getTopSellingProduct();
    }, []);

    const getTopSellingProduct = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const res = await fetchAllDataAPI('super-admin-get-top-selling-product');
            if (res.data.status === 1) {
                setTopProduct(res.data.topdata);
            } else {
                setError('Failed to fetch data.');
            }
        } catch (error) {
            console.error('Failed to fetch top selling products:', error);
            setError('Failed to fetch data.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTopProductRange = (event, picker) => {
        const selectedRange = {
            startDate: picker.startDate.format('MM/DD/YYYY'),
            endDate: picker.endDate.format('MM/DD/YYYY'),
        };
        setDateRange(selectedRange);
        setIsLoading(true);
        setError(null);
        addFormData('super-admin-get-filter-top-product-range', selectedRange)
            .then((res) => {
                if (res.data.status === 1) {
                    setTopProduct(res.data.topdata);
                } else {
                    setTopProduct([]);
                    setError('No data found for the selected range.');
                }
            })
            .catch((error) => {
                console.error('Error fetching filtered top products:', error);
                setError('Failed to fetch data for the selected range.');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="topagentproduct card radius-10 overflow-hidden w-100">
            <div className="card-header border-bottom bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 style={{marginLeft:"5px"}}>Top Selling Products</h6>
                    <DateRangePicker
                        initialSettings={{
                            startDate: dateRange.startDate,
                            endDate: dateRange.endDate,
                        }}
                        onApply={handleTopProductRange}
                    >
                        <button className="btn btn-sm btndateramge">Select Date Range</button>
                    </DateRangePicker>
                </div>
            </div>
            <div className="topagentproductsection">
                {isLoading ? (
                    Array.from({ length: 10 }, (_, index) => (
                        <Skeleton key={index} width="100%" animation="wave" />
                    ))
                ) : error ? (
                    <div className="text-center text-danger">{error}</div>
                ) : topproduct.length ? (
                    topproduct.map((product, index) => (
                        <div className="agentbody d-flex justify-content-between" key={index}>
                            <span className="name">{product?.p_name}</span>
                            <span className="tcount">{product?.total}</span>
                        </div>
                    ))
                ) : (
                    <div className="text-center">Data not found...</div>
                )}
            </div>
        </div>
    );
};

export default withAuth(TopProductSale);
